import { render, staticRenderFns } from "./DefaultPayrunModalMedia.vue?vue&type=template&id=0619315a&scoped=true&"
import script from "./DefaultPayrunModalMedia.vue?vue&type=script&lang=js&"
export * from "./DefaultPayrunModalMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0619315a",
  null
  
)

export default component.exports